import { Component, OnInit } from '@angular/core';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'knbr-kn-br-customer-download-link',
    templateUrl: './kn-br-customer-download-link.component.html',
    styleUrls: ['./kn-br-customer-download-link.component.scss'],
    imports: [TranslatePipe]
})
export class KnBrCustomerDownloadLinkComponent implements OnInit {
  constructor(private knBrCommonService: KnBrCommonService) {}

  ngOnInit(): void {}

  downloadCustomerList() {
    this.knBrCommonService.downloadCustomerList();
  }
}
